// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module--button--YHBmE","button__squared":"styles-module--button__squared--8bJxD"};